module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_book"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', [_c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 3) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n            " + _vm._s(teacherpublication.context) + "\n          ")]) : _c('span', [_c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.author))
      }
    }), _vm._v(", " + _vm._s(_vm.publication(teacherpublication)) + ",\n            "), _c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.title))
      }
    }), _vm._v(", " + _vm._s(_vm.showName(teacherpublication)) + "\n          ")])]) : _vm._e()
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85eefcaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeacherBook.vue
// module id = 1273
// module chunks = 4